import React, { useContext as useContextCore } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import type { CompanyWithContacts } from '@ztechapps/common.contract'
import { useCompanyWithContactsList } from './hooks/useCompanyWithContactsList'

export type CompanyListContextType = {
  listResult: UseListResult<CompanyWithContacts>
}

const context = React.createContext<CompanyListContextType>({} as CompanyListContextType)
const CoreProvider = context.Provider

type CompanyListProviderProps = {
  children: React.ReactNode
}

export const CompanyListProvider = ({ children }: CompanyListProviderProps) => {
  const listResult = useCompanyWithContactsList()

  return (
    <CoreProvider
      value={{
        listResult,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useCompanyListContext = () => useContextCore(context)
